var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length > 0)?_c('div',{staticClass:"list"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"listbox"},_vm._l((_vm.list),function(item,index){return _c('router-link',{key:index,staticClass:"item",attrs:{"to":{
          path: _vm.$Router.servicescontent.path,
          query: {
            id: item.id,
          },
        }}},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n            "+_vm._s(item.description)+"\n          ")])])])}),1)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toptitle"},[_c('p',[_vm._v("服务项目")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082f77a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/list/list.vue
// module id = null
// module chunks = 